<div class="data-model-customization-header">
    <span class="data-model-customization-header-title" (click)="selectClass(class.index)" *ngFor="let class of classes"
        [ngClass]="{'selected': class == currentClass}">
        {{ class.label | translate }}
    </span>
</div>
<div class="data-model-customization-title">
    <div class="row">
        <div class="col-sm-8">
            <h2>{{ currentClass.label | translate }}</h2>
        </div>
        <div class="col-sm-4 new-section">
            <button class="section-button" (click)="addNew()"><span class="plus-icon"><svg width="13" height="12" viewBox="0 0 13 12" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.75 0.75V6M6.75 6V11.25M6.75 6H1.5M6.75 6H12" stroke="#17171A" stroke-width="1.5"
                            stroke-linecap="round" />
                    </svg>
                </span>{{ 'DATA_MODEL_CUSTOMIZATION.NEW_SECTION' | translate }}</button>
        </div>
    </div>
</div>